interface WtnConfidenceBands {
  min: number;
  color: string;
}
export interface Env {
  teamsAPI: string;
  dualMatchesAPI: string;
  tennisDataAPI: string;
  wtnAPI: string;
  teamUrl: string;
  root: string;
  auth: string;
  site: string;
  features: {
    wtnConfidenceBands: WtnConfidenceBands[];
  };
  wtnPlayerSearchUrl: string;
}
export interface Team {
  schoolId: string;
  teamId: string;
  teamLogo: string;
  teamUrl: string;
  playersModule: boolean;
}

export interface Coaches {
  name?: string;
  phone?: string;
  email?: string;
  role?: string;
}

export const getEnvConfig = (): Env => {
  return (window as any)['envConfig'];
};

export const getTeamConfig = (): Team => {
  return (window as any)['teamConfig'];
};

export const getCoachData = (): Coaches[] => {
  return (window as any)['coachData'];
};

export interface countryType {
  [key: string]: {
    'code-source'?: string | null;
    name?: string | null;
    'alpha-2'?: string | null;
    'alpha-3'?: string | null;
    'ioc-code'?: string | null;
    'country-code'?: string | null;
  };
}

export const countries: countryType = {
  AFG: {
    'code-source': 'iso',
    name: 'Afghanistan',
    'alpha-2': 'AF',
    'alpha-3': 'AFG',
    'ioc-code': null,
    'country-code': '004'
  },
  ALA: {
    'code-source': 'iso',
    name: 'Åland Islands',
    'alpha-2': 'AX',
    'alpha-3': 'ALA',
    'ioc-code': null,
    'country-code': '248'
  },
  ALB: {
    'code-source': 'iso',
    name: 'Albania',
    'alpha-2': 'AL',
    'alpha-3': 'ALB',
    'ioc-code': null,
    'country-code': '008'
  },
  DZA: {
    'code-source': 'iso',
    name: 'Algeria',
    'alpha-2': 'DZ',
    'alpha-3': 'DZA',
    'ioc-code': 'ALG',
    'country-code': '012'
  },
  ASM: {
    'code-source': 'iso',
    name: 'American Samoa',
    'alpha-2': 'AS',
    'alpha-3': 'ASM',
    'ioc-code': 'ASA',
    'country-code': '016'
  },
  AND: {
    'code-source': 'iso',
    name: 'Andorra',
    'alpha-2': 'AD',
    'alpha-3': 'AND',
    'ioc-code': null,
    'country-code': '020'
  },
  AGO: {
    'code-source': 'iso',
    name: 'Angola',
    'alpha-2': 'AO',
    'alpha-3': 'AGO',
    'ioc-code': 'ANG',
    'country-code': '024'
  },
  AIA: {
    'code-source': 'iso',
    name: 'Anguilla',
    'alpha-2': 'AI',
    'alpha-3': 'AIA',
    'ioc-code': null,
    'country-code': '660'
  },
  ATA: {
    'code-source': 'iso',
    name: 'Antarctica',
    'alpha-2': 'AQ',
    'alpha-3': 'ATA',
    'ioc-code': null,
    'country-code': '010'
  },
  ATG: {
    'code-source': 'iso',
    name: 'Antigua and Barbuda',
    'alpha-2': 'AG',
    'alpha-3': 'ATG',
    'ioc-code': 'ANT',
    'country-code': '028'
  },
  ARG: {
    'code-source': 'iso',
    name: 'Argentina',
    'alpha-2': 'AR',
    'alpha-3': 'ARG',
    'ioc-code': null,
    'country-code': '032'
  },
  ARM: {
    'code-source': 'iso',
    name: 'Armenia',
    'alpha-2': 'AM',
    'alpha-3': 'ARM',
    'ioc-code': null,
    'country-code': '051'
  },
  ABW: {
    'code-source': 'iso',
    name: 'Aruba',
    'alpha-2': 'AW',
    'alpha-3': 'ABW',
    'ioc-code': 'ARU',
    'country-code': '533'
  },
  AUS: {
    'code-source': 'iso',
    name: 'Australia',
    'alpha-2': 'AU',
    'alpha-3': 'AUS',
    'ioc-code': null,
    'country-code': '036'
  },
  AUT: {
    'code-source': 'iso',
    name: 'Austria',
    'alpha-2': 'AT',
    'alpha-3': 'AUT',
    'ioc-code': null,
    'country-code': '040'
  },
  AZE: {
    'code-source': 'iso',
    name: 'Azerbaijan',
    'alpha-2': 'AZ',
    'alpha-3': 'AZE',
    'ioc-code': null,
    'country-code': '031'
  },
  BHS: {
    'code-source': 'iso',
    name: 'Bahamas',
    'alpha-2': 'BS',
    'alpha-3': 'BHS',
    'ioc-code': 'BAH',
    'country-code': '044'
  },
  BHR: {
    'code-source': 'iso',
    name: 'Bahrain',
    'alpha-2': 'BH',
    'alpha-3': 'BHR',
    'ioc-code': null,
    'country-code': '048'
  },
  BGD: {
    'code-source': 'iso',
    name: 'Bangladesh',
    'alpha-2': 'BD',
    'alpha-3': 'BGD',
    'ioc-code': 'BAN',
    'country-code': '050'
  },
  BRB: {
    'code-source': 'iso',
    name: 'Barbados',
    'alpha-2': 'BB',
    'alpha-3': 'BRB',
    'ioc-code': 'BAR',
    'country-code': '052'
  },
  BLR: {
    'code-source': 'iso',
    name: 'Belarus',
    'alpha-2': 'BY',
    'alpha-3': 'BLR',
    'ioc-code': null,
    'country-code': '112'
  },
  BEL: {
    'code-source': 'iso',
    name: 'Belgium',
    'alpha-2': 'BE',
    'alpha-3': 'BEL',
    'ioc-code': null,
    'country-code': '056'
  },
  BLZ: {
    'code-source': 'iso',
    name: 'Belize',
    'alpha-2': 'BZ',
    'alpha-3': 'BLZ',
    'ioc-code': 'BIZ',
    'country-code': '084'
  },
  BEN: {
    'code-source': 'iso',
    name: 'Benin',
    'alpha-2': 'BJ',
    'alpha-3': 'BEN',
    'ioc-code': null,
    'country-code': '204'
  },
  BMU: {
    'code-source': 'iso',
    name: 'Bermuda',
    'alpha-2': 'BM',
    'alpha-3': 'BMU',
    'ioc-code': 'BER',
    'country-code': '060'
  },
  BTN: {
    'code-source': 'iso',
    name: 'Bhutan',
    'alpha-2': 'BT',
    'alpha-3': 'BTN',
    'ioc-code': 'BHU',
    'country-code': '064'
  },
  BOL: {
    'code-source': 'iso',
    name: 'Bolivia (Plurinational State of)',
    'alpha-2': 'BO',
    'alpha-3': 'BOL',
    'ioc-code': null,
    'country-code': '068'
  },
  BES: {
    'code-source': 'iso',
    name: 'Bonaire, Sint Eustatius and Saba',
    'alpha-2': 'BQ',
    'alpha-3': 'BES',
    'ioc-code': null,
    'country-code': '535'
  },
  BIH: {
    'code-source': 'iso',
    name: 'Bosnia and Herzegovina',
    'alpha-2': 'BA',
    'alpha-3': 'BIH',
    'ioc-code': null,
    'country-code': '070'
  },
  BWA: {
    'code-source': 'iso',
    name: 'Botswana',
    'alpha-2': 'BW',
    'alpha-3': 'BWA',
    'ioc-code': 'BOT',
    'country-code': '072'
  },
  BVT: {
    'code-source': 'iso',
    name: 'Bouvet Island',
    'alpha-2': 'BV',
    'alpha-3': 'BVT',
    'ioc-code': null,
    'country-code': '074'
  },
  BRA: {
    'code-source': 'iso',
    name: 'Brazil',
    'alpha-2': 'BR',
    'alpha-3': 'BRA',
    'ioc-code': null,
    'country-code': '076'
  },
  IOT: {
    'code-source': 'iso',
    name: 'British Indian Ocean Territory',
    'alpha-2': 'IO',
    'alpha-3': 'IOT',
    'ioc-code': null,
    'country-code': '086'
  },
  BRN: {
    'code-source': 'iso',
    name: 'Brunei Darussalam',
    'alpha-2': 'BN',
    'alpha-3': 'BRN',
    'ioc-code': 'BRU',
    'country-code': '096'
  },
  BGR: {
    'code-source': 'iso',
    name: 'Bulgaria',
    'alpha-2': 'BG',
    'alpha-3': 'BGR',
    'ioc-code': 'BUL',
    'country-code': '100'
  },
  BFA: {
    'code-source': 'iso',
    name: 'Burkina Faso',
    'alpha-2': 'BF',
    'alpha-3': 'BFA',
    'ioc-code': 'BUR',
    'country-code': '854'
  },
  BDI: {
    'code-source': 'iso',
    name: 'Burundi',
    'alpha-2': 'BI',
    'alpha-3': 'BDI',
    'ioc-code': null,
    'country-code': '108'
  },
  CPV: {
    'code-source': 'iso',
    name: 'Cabo Verde',
    'alpha-2': 'CV',
    'alpha-3': 'CPV',
    'ioc-code': null,
    'country-code': '132'
  },
  KHM: {
    'code-source': 'iso',
    name: 'Cambodia',
    'alpha-2': 'KH',
    'alpha-3': 'KHM',
    'ioc-code': null,
    'country-code': '116'
  },
  CMR: {
    'code-source': 'iso',
    name: 'Cameroon',
    'alpha-2': 'CM',
    'alpha-3': 'CMR',
    'ioc-code': null,
    'country-code': '120'
  },
  CAN: {
    'code-source': 'iso',
    name: 'Canada',
    'alpha-2': 'CA',
    'alpha-3': 'CAN',
    'ioc-code': null,
    'country-code': '124'
  },
  CYM: {
    'code-source': 'iso',
    name: 'Cayman Islands',
    'alpha-2': 'KY',
    'alpha-3': 'CYM',
    'ioc-code': 'CAY',
    'country-code': '136'
  },
  CAF: {
    'code-source': 'iso',
    name: 'Central African Republic',
    'alpha-2': 'CF',
    'alpha-3': 'CAF',
    'ioc-code': null,
    'country-code': '140'
  },
  TCD: {
    'code-source': 'iso',
    name: 'Chad',
    'alpha-2': 'TD',
    'alpha-3': 'TCD',
    'ioc-code': 'CHA',
    'country-code': '148'
  },
  CHL: {
    'code-source': 'iso',
    name: 'Chile',
    'alpha-2': 'CL',
    'alpha-3': 'CHL',
    'ioc-code': 'CHI',
    'country-code': '152'
  },
  CHN: {
    'code-source': 'iso',
    name: 'China',
    'alpha-2': 'CN',
    'alpha-3': 'CHN',
    'ioc-code': null,
    'country-code': '156'
  },
  CXR: {
    'code-source': 'iso',
    name: 'Christmas Island',
    'alpha-2': 'CX',
    'alpha-3': 'CXR',
    'ioc-code': null,
    'country-code': '162'
  },
  CCK: {
    'code-source': 'iso',
    name: 'Cocos (Keeling) Islands',
    'alpha-2': 'CC',
    'alpha-3': 'CCK',
    'ioc-code': null,
    'country-code': '166'
  },
  COL: {
    'code-source': 'iso',
    name: 'Colombia',
    'alpha-2': 'CO',
    'alpha-3': 'COL',
    'ioc-code': null,
    'country-code': '170'
  },
  COM: {
    'code-source': 'iso',
    name: 'Comoros',
    'alpha-2': 'KM',
    'alpha-3': 'COM',
    'ioc-code': null,
    'country-code': '174'
  },
  COG: {
    'code-source': 'iso',
    name: 'Congo',
    'alpha-2': 'CG',
    'alpha-3': 'COG',
    'ioc-code': 'CGO',
    'country-code': '178'
  },
  COD: {
    'code-source': 'iso',
    name: 'Congo, Democratic Republic of the',
    'alpha-2': 'CD',
    'alpha-3': 'COD',
    'ioc-code': null,
    'country-code': '180'
  },
  COK: {
    'code-source': 'iso',
    name: 'Cook Islands',
    'alpha-2': 'CK',
    'alpha-3': 'COK',
    'ioc-code': null,
    'country-code': '184'
  },
  CRI: {
    'code-source': 'iso',
    name: 'Costa Rica',
    'alpha-2': 'CR',
    'alpha-3': 'CRI',
    'ioc-code': 'CRC',
    'country-code': '188'
  },
  CIV: {
    'code-source': 'iso',
    name: "Côte d'Ivoire",
    'alpha-2': 'CI',
    'alpha-3': 'CIV',
    'ioc-code': null,
    'country-code': '384'
  },
  HRV: {
    'code-source': 'iso',
    name: 'Croatia',
    'alpha-2': 'HR',
    'alpha-3': 'HRV',
    'ioc-code': 'CRO',
    'country-code': '191'
  },
  CUB: {
    'code-source': 'iso',
    name: 'Cuba',
    'alpha-2': 'CU',
    'alpha-3': 'CUB',
    'ioc-code': null,
    'country-code': '192'
  },
  CUW: {
    'code-source': 'iso',
    name: 'Curaçao',
    'alpha-2': 'CW',
    'alpha-3': 'CUW',
    'ioc-code': null,
    'country-code': '531'
  },
  CYP: {
    'code-source': 'iso',
    name: 'Cyprus',
    'alpha-2': 'CY',
    'alpha-3': 'CYP',
    'ioc-code': null,
    'country-code': '196'
  },
  CZE: {
    'code-source': 'iso',
    name: 'Czechia',
    'alpha-2': 'CZ',
    'alpha-3': 'CZE',
    'ioc-code': null,
    'country-code': '203'
  },
  DNK: {
    'code-source': 'iso',
    name: 'Denmark',
    'alpha-2': 'DK',
    'alpha-3': 'DNK',
    'ioc-code': 'DEN',
    'country-code': '208'
  },
  DJI: {
    'code-source': 'iso',
    name: 'Djibouti',
    'alpha-2': 'DJ',
    'alpha-3': 'DJI',
    'ioc-code': null,
    'country-code': '262'
  },
  DMA: {
    'code-source': 'iso',
    name: 'Dominica',
    'alpha-2': 'DM',
    'alpha-3': 'DMA',
    'ioc-code': null,
    'country-code': '212'
  },
  DOM: {
    'code-source': 'iso',
    name: 'Dominican Republic',
    'alpha-2': 'DO',
    'alpha-3': 'DOM',
    'ioc-code': null,
    'country-code': '214'
  },
  ECU: {
    'code-source': 'iso',
    name: 'Ecuador',
    'alpha-2': 'EC',
    'alpha-3': 'ECU',
    'ioc-code': null,
    'country-code': '218'
  },
  EGY: {
    'code-source': 'iso',
    name: 'Egypt',
    'alpha-2': 'EG',
    'alpha-3': 'EGY',
    'ioc-code': null,
    'country-code': '818'
  },
  SLV: {
    'code-source': 'iso',
    name: 'El Salvador',
    'alpha-2': 'SV',
    'alpha-3': 'SLV',
    'ioc-code': 'ESA',
    'country-code': '222'
  },
  GNQ: {
    'code-source': 'iso',
    name: 'Equatorial Guinea',
    'alpha-2': 'GQ',
    'alpha-3': 'GNQ',
    'ioc-code': 'GEQ',
    'country-code': '226'
  },
  ERI: {
    'code-source': 'iso',
    name: 'Eritrea',
    'alpha-2': 'ER',
    'alpha-3': 'ERI',
    'ioc-code': null,
    'country-code': '232'
  },
  EST: {
    'code-source': 'iso',
    name: 'Estonia',
    'alpha-2': 'EE',
    'alpha-3': 'EST',
    'ioc-code': null,
    'country-code': '233'
  },
  SWZ: {
    'code-source': 'iso',
    name: 'Eswatini',
    'alpha-2': 'SZ',
    'alpha-3': 'SWZ',
    'ioc-code': null,
    'country-code': '748'
  },
  ETH: {
    'code-source': 'iso',
    name: 'Ethiopia',
    'alpha-2': 'ET',
    'alpha-3': 'ETH',
    'ioc-code': null,
    'country-code': '231'
  },
  FLK: {
    'code-source': 'iso',
    name: 'Falkland Islands (Malvinas)',
    'alpha-2': 'FK',
    'alpha-3': 'FLK',
    'ioc-code': null,
    'country-code': '238'
  },
  FRO: {
    'code-source': 'iso',
    name: 'Faroe Islands',
    'alpha-2': 'FO',
    'alpha-3': 'FRO',
    'ioc-code': null,
    'country-code': '234'
  },
  FJI: {
    'code-source': 'iso',
    name: 'Fiji',
    'alpha-2': 'FJ',
    'alpha-3': 'FJI',
    'ioc-code': 'FIJ',
    'country-code': '242'
  },
  FIN: {
    'code-source': 'iso',
    name: 'Finland',
    'alpha-2': 'FI',
    'alpha-3': 'FIN',
    'ioc-code': null,
    'country-code': '246'
  },
  FRA: {
    'code-source': 'iso',
    name: 'France',
    'alpha-2': 'FR',
    'alpha-3': 'FRA',
    'ioc-code': null,
    'country-code': '250'
  },
  GUF: {
    'code-source': 'iso',
    name: 'French Guiana',
    'alpha-2': 'GF',
    'alpha-3': 'GUF',
    'ioc-code': null,
    'country-code': '254'
  },
  PYF: {
    'code-source': 'iso',
    name: 'French Polynesia',
    'alpha-2': 'PF',
    'alpha-3': 'PYF',
    'ioc-code': null,
    'country-code': '258'
  },
  ATF: {
    'code-source': 'iso',
    name: 'French Southern Territories',
    'alpha-2': 'TF',
    'alpha-3': 'ATF',
    'ioc-code': null,
    'country-code': '260'
  },
  GAB: {
    'code-source': 'iso',
    name: 'Gabon',
    'alpha-2': 'GA',
    'alpha-3': 'GAB',
    'ioc-code': null,
    'country-code': '266'
  },
  GMB: {
    'code-source': 'iso',
    name: 'Gambia',
    'alpha-2': 'GM',
    'alpha-3': 'GMB',
    'ioc-code': null,
    'country-code': '270'
  },
  GEO: {
    'code-source': 'iso',
    name: 'Georgia',
    'alpha-2': 'GE',
    'alpha-3': 'GEO',
    'ioc-code': null,
    'country-code': '268'
  },
  DEU: {
    'code-source': 'iso',
    name: 'Germany',
    'alpha-2': 'DE',
    'alpha-3': 'DEU',
    'ioc-code': 'GER',
    'country-code': '276'
  },
  GHA: {
    'code-source': 'iso',
    name: 'Ghana',
    'alpha-2': 'GH',
    'alpha-3': 'GHA',
    'ioc-code': null,
    'country-code': '288'
  },
  GIB: {
    'code-source': 'iso',
    name: 'Gibraltar',
    'alpha-2': 'GI',
    'alpha-3': 'GIB',
    'ioc-code': null,
    'country-code': '292'
  },
  GRC: {
    'code-source': 'iso',
    name: 'Greece',
    'alpha-2': 'GR',
    'alpha-3': 'GRC',
    'ioc-code': 'GRE',
    'country-code': '300'
  },
  GRL: {
    'code-source': 'iso',
    name: 'Greenland',
    'alpha-2': 'GL',
    'alpha-3': 'GRL',
    'ioc-code': null,
    'country-code': '304'
  },
  GRD: {
    'code-source': 'iso',
    name: 'Grenada',
    'alpha-2': 'GD',
    'alpha-3': 'GRD',
    'ioc-code': 'GRN',
    'country-code': '308'
  },
  GLP: {
    'code-source': 'iso',
    name: 'Guadeloupe',
    'alpha-2': 'GP',
    'alpha-3': 'GLP',
    'ioc-code': null,
    'country-code': '312'
  },
  GUM: {
    'code-source': 'iso',
    name: 'Guam',
    'alpha-2': 'GU',
    'alpha-3': 'GUM',
    'ioc-code': null,
    'country-code': '316'
  },
  GTM: {
    'code-source': 'iso',
    name: 'Guatemala',
    'alpha-2': 'GT',
    'alpha-3': 'GTM',
    'ioc-code': 'GUA',
    'country-code': '320'
  },
  GGY: {
    'code-source': 'iso',
    name: 'Guernsey',
    'alpha-2': 'GG',
    'alpha-3': 'GGY',
    'ioc-code': null,
    'country-code': '831'
  },
  GIN: {
    'code-source': 'iso',
    name: 'Guinea',
    'alpha-2': 'GN',
    'alpha-3': 'GIN',
    'ioc-code': 'GUI',
    'country-code': '324'
  },
  GNB: {
    'code-source': 'iso',
    name: 'Guinea-Bissau',
    'alpha-2': 'GW',
    'alpha-3': 'GNB',
    'ioc-code': 'GBS',
    'country-code': '624'
  },
  GUY: {
    'code-source': 'iso',
    name: 'Guyana',
    'alpha-2': 'GY',
    'alpha-3': 'GUY',
    'ioc-code': null,
    'country-code': '328'
  },
  HTI: {
    'code-source': 'iso',
    name: 'Haiti',
    'alpha-2': 'HT',
    'alpha-3': 'HTI',
    'ioc-code': 'HAI',
    'country-code': '332'
  },
  HMD: {
    'code-source': 'iso',
    name: 'Heard Island and McDonald Islands',
    'alpha-2': 'HM',
    'alpha-3': 'HMD',
    'ioc-code': null,
    'country-code': '334'
  },
  VAT: {
    'code-source': 'iso',
    name: 'Holy See',
    'alpha-2': 'VA',
    'alpha-3': 'VAT',
    'ioc-code': null,
    'country-code': '336'
  },
  HND: {
    'code-source': 'iso',
    name: 'Honduras',
    'alpha-2': 'HN',
    'alpha-3': 'HND',
    'ioc-code': 'HON',
    'country-code': '340'
  },
  HKG: {
    'code-source': 'iso',
    name: 'Hong Kong',
    'alpha-2': 'HK',
    'alpha-3': 'HKG',
    'ioc-code': null,
    'country-code': '344'
  },
  HUN: {
    'code-source': 'iso',
    name: 'Hungary',
    'alpha-2': 'HU',
    'alpha-3': 'HUN',
    'ioc-code': null,
    'country-code': '348'
  },
  ISL: {
    'code-source': 'iso',
    name: 'Iceland',
    'alpha-2': 'IS',
    'alpha-3': 'ISL',
    'ioc-code': null,
    'country-code': '352'
  },
  IND: {
    'code-source': 'iso',
    name: 'India',
    'alpha-2': 'IN',
    'alpha-3': 'IND',
    'ioc-code': null,
    'country-code': '356'
  },
  IDN: {
    'code-source': 'iso',
    name: 'Indonesia',
    'alpha-2': 'ID',
    'alpha-3': 'IDN',
    'ioc-code': 'INA',
    'country-code': '360'
  },
  IRN: {
    'code-source': 'iso',
    name: 'Iran (Islamic Republic of)',
    'alpha-2': 'IR',
    'alpha-3': 'IRN',
    'ioc-code': 'IRI',
    'country-code': '364'
  },
  IRQ: {
    'code-source': 'iso',
    name: 'Iraq',
    'alpha-2': 'IQ',
    'alpha-3': 'IRQ',
    'ioc-code': null,
    'country-code': '368'
  },
  IRL: {
    'code-source': 'iso',
    name: 'Ireland',
    'alpha-2': 'IE',
    'alpha-3': 'IRL',
    'ioc-code': null,
    'country-code': '372'
  },
  IMN: {
    'code-source': 'iso',
    name: 'Isle of Man',
    'alpha-2': 'IM',
    'alpha-3': 'IMN',
    'ioc-code': null,
    'country-code': '833'
  },
  ISR: {
    'code-source': 'iso',
    name: 'Israel',
    'alpha-2': 'IL',
    'alpha-3': 'ISR',
    'ioc-code': null,
    'country-code': '376'
  },
  ITA: {
    'code-source': 'iso',
    name: 'Italy',
    'alpha-2': 'IT',
    'alpha-3': 'ITA',
    'ioc-code': null,
    'country-code': '380'
  },
  JAM: {
    'code-source': 'iso',
    name: 'Jamaica',
    'alpha-2': 'JM',
    'alpha-3': 'JAM',
    'ioc-code': null,
    'country-code': '388'
  },
  JPN: {
    'code-source': 'iso',
    name: 'Japan',
    'alpha-2': 'JP',
    'alpha-3': 'JPN',
    'ioc-code': null,
    'country-code': '392'
  },
  JEY: {
    'code-source': 'iso',
    name: 'Jersey',
    'alpha-2': 'JE',
    'alpha-3': 'JEY',
    'ioc-code': null,
    'country-code': '832'
  },
  JOR: {
    'code-source': 'iso',
    name: 'Jordan',
    'alpha-2': 'JO',
    'alpha-3': 'JOR',
    'ioc-code': null,
    'country-code': '400'
  },
  KAZ: {
    'code-source': 'iso',
    name: 'Kazakhstan',
    'alpha-2': 'KZ',
    'alpha-3': 'KAZ',
    'ioc-code': null,
    'country-code': '398'
  },
  KEN: {
    'code-source': 'iso',
    name: 'Kenya',
    'alpha-2': 'KE',
    'alpha-3': 'KEN',
    'ioc-code': null,
    'country-code': '404'
  },
  KIR: {
    'code-source': 'iso',
    name: 'Kiribati',
    'alpha-2': 'KI',
    'alpha-3': 'KIR',
    'ioc-code': null,
    'country-code': '296'
  },
  PRK: {
    'code-source': 'iso',
    name: "Korea (Democratic People's Republic of)",
    'alpha-2': 'KP',
    'alpha-3': 'PRK',
    'ioc-code': null,
    'country-code': '408'
  },
  KOR: {
    'code-source': 'iso',
    name: 'Korea, Republic of',
    'alpha-2': 'KR',
    'alpha-3': 'KOR',
    'ioc-code': null,
    'country-code': '410'
  },
  KWT: {
    'code-source': 'iso',
    name: 'Kuwait',
    'alpha-2': 'KW',
    'alpha-3': 'KWT',
    'ioc-code': 'KUW',
    'country-code': '414'
  },
  KGZ: {
    'code-source': 'iso',
    name: 'Kyrgyzstan',
    'alpha-2': 'KG',
    'alpha-3': 'KGZ',
    'ioc-code': null,
    'country-code': '417'
  },
  LAO: {
    'code-source': 'iso',
    name: "Lao People's Democratic Republic",
    'alpha-2': 'LA',
    'alpha-3': 'LAO',
    'ioc-code': null,
    'country-code': '418'
  },
  LVA: {
    'code-source': 'iso',
    name: 'Latvia',
    'alpha-2': 'LV',
    'alpha-3': 'LVA',
    'ioc-code': 'LAT',
    'country-code': '428'
  },
  LBN: {
    'code-source': 'iso',
    name: 'Lebanon',
    'alpha-2': 'LB',
    'alpha-3': 'LBN',
    'ioc-code': null,
    'country-code': '422'
  },
  LSO: {
    'code-source': 'iso',
    name: 'Lesotho',
    'alpha-2': 'LS',
    'alpha-3': 'LSO',
    'ioc-code': 'LES',
    'country-code': '426'
  },
  LBR: {
    'code-source': 'iso',
    name: 'Liberia',
    'alpha-2': 'LR',
    'alpha-3': 'LBR',
    'ioc-code': null,
    'country-code': '430'
  },
  LBY: {
    'code-source': 'iso',
    name: 'Libya',
    'alpha-2': 'LY',
    'alpha-3': 'LBY',
    'ioc-code': 'LBA',
    'country-code': '434'
  },
  LIE: {
    'code-source': 'iso',
    name: 'Liechtenstein',
    'alpha-2': 'LI',
    'alpha-3': 'LIE',
    'ioc-code': null,
    'country-code': '438'
  },
  LTU: {
    'code-source': 'iso',
    name: 'Lithuania',
    'alpha-2': 'LT',
    'alpha-3': 'LTU',
    'ioc-code': null,
    'country-code': '440'
  },
  LUX: {
    'code-source': 'iso',
    name: 'Luxembourg',
    'alpha-2': 'LU',
    'alpha-3': 'LUX',
    'ioc-code': null,
    'country-code': '442'
  },
  MAC: {
    'code-source': 'iso',
    name: 'Macao',
    'alpha-2': 'MO',
    'alpha-3': 'MAC',
    'ioc-code': null,
    'country-code': '446'
  },
  MDG: {
    'code-source': 'iso',
    name: 'Madagascar',
    'alpha-2': 'MG',
    'alpha-3': 'MDG',
    'ioc-code': 'MAD',
    'country-code': '450'
  },
  MWI: {
    'code-source': 'iso',
    name: 'Malawi',
    'alpha-2': 'MW',
    'alpha-3': 'MWI',
    'ioc-code': 'MAW',
    'country-code': '454'
  },
  MYS: {
    'code-source': 'iso',
    name: 'Malaysia',
    'alpha-2': 'MY',
    'alpha-3': 'MYS',
    'ioc-code': 'MAS',
    'country-code': '458'
  },
  MDV: {
    'code-source': 'iso',
    name: 'Maldives',
    'alpha-2': 'MV',
    'alpha-3': 'MDV',
    'ioc-code': null,
    'country-code': '462'
  },
  MLI: {
    'code-source': 'iso',
    name: 'Mali',
    'alpha-2': 'ML',
    'alpha-3': 'MLI',
    'ioc-code': null,
    'country-code': '466'
  },
  MLT: {
    'code-source': 'iso',
    name: 'Malta',
    'alpha-2': 'MT',
    'alpha-3': 'MLT',
    'ioc-code': null,
    'country-code': '470'
  },
  MHL: {
    'code-source': 'iso',
    name: 'Marshall Islands',
    'alpha-2': 'MH',
    'alpha-3': 'MHL',
    'ioc-code': null,
    'country-code': '584'
  },
  MTQ: {
    'code-source': 'iso',
    name: 'Martinique',
    'alpha-2': 'MQ',
    'alpha-3': 'MTQ',
    'ioc-code': null,
    'country-code': '474'
  },
  MRT: {
    'code-source': 'iso',
    name: 'Mauritania',
    'alpha-2': 'MR',
    'alpha-3': 'MRT',
    'ioc-code': 'MTN',
    'country-code': '478'
  },
  MUS: {
    'code-source': 'iso',
    name: 'Mauritius',
    'alpha-2': 'MU',
    'alpha-3': 'MUS',
    'ioc-code': 'MRI',
    'country-code': '480'
  },
  MYT: {
    'code-source': 'iso',
    name: 'Mayotte',
    'alpha-2': 'YT',
    'alpha-3': 'MYT',
    'ioc-code': null,
    'country-code': '175'
  },
  MEX: {
    'code-source': 'iso',
    name: 'Mexico',
    'alpha-2': 'MX',
    'alpha-3': 'MEX',
    'ioc-code': null,
    'country-code': '484'
  },
  FSM: {
    'code-source': 'iso',
    name: 'Micronesia (Federated States of)',
    'alpha-2': 'FM',
    'alpha-3': 'FSM',
    'ioc-code': null,
    'country-code': '583'
  },
  MDA: {
    'code-source': 'iso',
    name: 'Moldova, Republic of',
    'alpha-2': 'MD',
    'alpha-3': 'MDA',
    'ioc-code': null,
    'country-code': '498'
  },
  MCO: {
    'code-source': 'iso',
    name: 'Monaco',
    'alpha-2': 'MC',
    'alpha-3': 'MCO',
    'ioc-code': 'MON',
    'country-code': '492'
  },
  MNG: {
    'code-source': 'iso',
    name: 'Mongolia',
    'alpha-2': 'MN',
    'alpha-3': 'MNG',
    'ioc-code': 'MGL',
    'country-code': '496'
  },
  MNE: {
    'code-source': 'iso',
    name: 'Montenegro',
    'alpha-2': 'ME',
    'alpha-3': 'MNE',
    'ioc-code': null,
    'country-code': '499'
  },
  MSR: {
    'code-source': 'iso',
    name: 'Montserrat',
    'alpha-2': 'MS',
    'alpha-3': 'MSR',
    'ioc-code': null,
    'country-code': '500'
  },
  MAR: {
    'code-source': 'iso',
    name: 'Morocco',
    'alpha-2': 'MA',
    'alpha-3': 'MAR',
    'ioc-code': null,
    'country-code': '504'
  },
  MOZ: {
    'code-source': 'iso',
    name: 'Mozambique',
    'alpha-2': 'MZ',
    'alpha-3': 'MOZ',
    'ioc-code': null,
    'country-code': '508'
  },
  MMR: {
    'code-source': 'iso',
    name: 'Myanmar',
    'alpha-2': 'MM',
    'alpha-3': 'MMR',
    'ioc-code': 'MYA',
    'country-code': '104'
  },
  NAM: {
    'code-source': 'iso',
    name: 'Namibia',
    'alpha-2': 'NA',
    'alpha-3': 'NAM',
    'ioc-code': null,
    'country-code': '516'
  },
  NRU: {
    'code-source': 'iso',
    name: 'Nauru',
    'alpha-2': 'NR',
    'alpha-3': 'NRU',
    'ioc-code': null,
    'country-code': '520'
  },
  NPL: {
    'code-source': 'iso',
    name: 'Nepal',
    'alpha-2': 'NP',
    'alpha-3': 'NPL',
    'ioc-code': 'NEP',
    'country-code': '524'
  },
  NLD: {
    'code-source': 'iso',
    name: 'Netherlands',
    'alpha-2': 'NL',
    'alpha-3': 'NLD',
    'ioc-code': 'NED',
    'country-code': '528'
  },
  NCL: {
    'code-source': 'iso',
    name: 'New Caledonia',
    'alpha-2': 'NC',
    'alpha-3': 'NCL',
    'ioc-code': null,
    'country-code': '540'
  },
  NZL: {
    'code-source': 'iso',
    name: 'New Zealand',
    'alpha-2': 'NZ',
    'alpha-3': 'NZL',
    'ioc-code': null,
    'country-code': '554'
  },
  NIC: {
    'code-source': 'iso',
    name: 'Nicaragua',
    'alpha-2': 'NI',
    'alpha-3': 'NIC',
    'ioc-code': 'NCA',
    'country-code': '558'
  },
  NER: {
    'code-source': 'iso',
    name: 'Niger',
    'alpha-2': 'NE',
    'alpha-3': 'NER',
    'ioc-code': 'NIG',
    'country-code': '562'
  },
  NGA: {
    'code-source': 'iso',
    name: 'Nigeria',
    'alpha-2': 'NG',
    'alpha-3': 'NGA',
    'ioc-code': 'NGR',
    'country-code': '566'
  },
  NIU: {
    'code-source': 'iso',
    name: 'Niue',
    'alpha-2': 'NU',
    'alpha-3': 'NIU',
    'ioc-code': null,
    'country-code': '570'
  },
  NFK: {
    'code-source': 'iso',
    name: 'Norfolk Island',
    'alpha-2': 'NF',
    'alpha-3': 'NFK',
    'ioc-code': null,
    'country-code': '574'
  },
  MKD: {
    'code-source': 'iso',
    name: 'North Macedonia',
    'alpha-2': 'MK',
    'alpha-3': 'MKD',
    'ioc-code': null,
    'country-code': '807'
  },
  MNP: {
    'code-source': 'iso',
    name: 'Northern Mariana Islands',
    'alpha-2': 'MP',
    'alpha-3': 'MNP',
    'ioc-code': null,
    'country-code': '580'
  },
  NOR: {
    'code-source': 'iso',
    name: 'Norway',
    'alpha-2': 'NO',
    'alpha-3': 'NOR',
    'ioc-code': null,
    'country-code': '578'
  },
  OMN: {
    'code-source': 'iso',
    name: 'Oman',
    'alpha-2': 'OM',
    'alpha-3': 'OMN',
    'ioc-code': 'OMA',
    'country-code': '512'
  },
  PAK: {
    'code-source': 'iso',
    name: 'Pakistan',
    'alpha-2': 'PK',
    'alpha-3': 'PAK',
    'ioc-code': null,
    'country-code': '586'
  },
  PLW: {
    'code-source': 'iso',
    name: 'Palau',
    'alpha-2': 'PW',
    'alpha-3': 'PLW',
    'ioc-code': null,
    'country-code': '585'
  },
  PSE: {
    'code-source': 'iso',
    name: 'Palestine, State of',
    'alpha-2': 'PS',
    'alpha-3': 'PSE',
    'ioc-code': 'PLE',
    'country-code': '275'
  },
  PAN: {
    'code-source': 'iso',
    name: 'Panama',
    'alpha-2': 'PA',
    'alpha-3': 'PAN',
    'ioc-code': null,
    'country-code': '591'
  },
  PNG: {
    'code-source': 'iso',
    name: 'Papua New Guinea',
    'alpha-2': 'PG',
    'alpha-3': 'PNG',
    'ioc-code': null,
    'country-code': '598'
  },
  PRY: {
    'code-source': 'iso',
    name: 'Paraguay',
    'alpha-2': 'PY',
    'alpha-3': 'PRY',
    'ioc-code': 'PAR',
    'country-code': '600'
  },
  PER: {
    'code-source': 'iso',
    name: 'Peru',
    'alpha-2': 'PE',
    'alpha-3': 'PER',
    'ioc-code': null,
    'country-code': '604'
  },
  PHL: {
    'code-source': 'iso',
    name: 'Philippines',
    'alpha-2': 'PH',
    'alpha-3': 'PHL',
    'ioc-code': 'PHI',
    'country-code': '608'
  },
  PCN: {
    'code-source': 'iso',
    name: 'Pitcairn',
    'alpha-2': 'PN',
    'alpha-3': 'PCN',
    'ioc-code': null,
    'country-code': '612'
  },
  POL: {
    'code-source': 'iso',
    name: 'Poland',
    'alpha-2': 'PL',
    'alpha-3': 'POL',
    'ioc-code': null,
    'country-code': '616'
  },
  PRT: {
    'code-source': 'iso',
    name: 'Portugal',
    'alpha-2': 'PT',
    'alpha-3': 'PRT',
    'ioc-code': 'POR',
    'country-code': '620'
  },
  PRI: {
    'code-source': 'iso',
    name: 'Puerto Rico',
    'alpha-2': 'PR',
    'alpha-3': 'PRI',
    'ioc-code': 'PUR',
    'country-code': '630'
  },
  QAT: {
    'code-source': 'iso',
    name: 'Qatar',
    'alpha-2': 'QA',
    'alpha-3': 'QAT',
    'ioc-code': null,
    'country-code': '634'
  },
  REU: {
    'code-source': 'iso',
    name: 'Réunion',
    'alpha-2': 'RE',
    'alpha-3': 'REU',
    'ioc-code': null,
    'country-code': '638'
  },
  ROU: {
    'code-source': 'iso',
    name: 'Romania',
    'alpha-2': 'RO',
    'alpha-3': 'ROU',
    'ioc-code': null,
    'country-code': '642'
  },
  RUS: {
    'code-source': 'iso',
    name: 'Russian Federation',
    'alpha-2': 'RU',
    'alpha-3': 'RUS',
    'ioc-code': null,
    'country-code': '643'
  },
  RWA: {
    'code-source': 'iso',
    name: 'Rwanda',
    'alpha-2': 'RW',
    'alpha-3': 'RWA',
    'ioc-code': null,
    'country-code': '646'
  },
  BLM: {
    'code-source': 'iso',
    name: 'Saint Barthélemy',
    'alpha-2': 'BL',
    'alpha-3': 'BLM',
    'ioc-code': null,
    'country-code': '652'
  },
  SHN: {
    'code-source': 'iso',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    'alpha-2': 'SH',
    'alpha-3': 'SHN',
    'ioc-code': null,
    'country-code': '654'
  },
  KNA: {
    'code-source': 'iso',
    name: 'Saint Kitts and Nevis',
    'alpha-2': 'KN',
    'alpha-3': 'KNA',
    'ioc-code': 'SKN',
    'country-code': '659'
  },
  LCA: {
    'code-source': 'iso',
    name: 'Saint Lucia',
    'alpha-2': 'LC',
    'alpha-3': 'LCA',
    'ioc-code': null,
    'country-code': '662'
  },
  MAF: {
    'code-source': 'iso',
    name: 'Saint Martin (French part)',
    'alpha-2': 'MF',
    'alpha-3': 'MAF',
    'ioc-code': null,
    'country-code': '663'
  },
  SPM: {
    'code-source': 'iso',
    name: 'Saint Pierre and Miquelon',
    'alpha-2': 'PM',
    'alpha-3': 'SPM',
    'ioc-code': null,
    'country-code': '666'
  },
  VCT: {
    'code-source': 'iso',
    name: 'Saint Vincent and the Grenadines',
    'alpha-2': 'VC',
    'alpha-3': 'VCT',
    'ioc-code': 'VIN',
    'country-code': '670'
  },
  WSM: {
    'code-source': 'iso',
    name: 'Samoa',
    'alpha-2': 'WS',
    'alpha-3': 'WSM',
    'ioc-code': null,
    'country-code': '882'
  },
  SMR: {
    'code-source': 'iso',
    name: 'San Marino',
    'alpha-2': 'SM',
    'alpha-3': 'SMR',
    'ioc-code': null,
    'country-code': '674'
  },
  STP: {
    'code-source': 'iso',
    name: 'Sao Tome and Principe',
    'alpha-2': 'ST',
    'alpha-3': 'STP',
    'ioc-code': null,
    'country-code': '678'
  },
  SAU: {
    'code-source': 'iso',
    name: 'Saudi Arabia',
    'alpha-2': 'SA',
    'alpha-3': 'SAU',
    'ioc-code': 'KSA',
    'country-code': '682'
  },
  SEN: {
    'code-source': 'iso',
    name: 'Senegal',
    'alpha-2': 'SN',
    'alpha-3': 'SEN',
    'ioc-code': null,
    'country-code': '686'
  },
  SRB: {
    'code-source': 'iso',
    name: 'Serbia',
    'alpha-2': 'RS',
    'alpha-3': 'SRB',
    'ioc-code': null,
    'country-code': '688'
  },
  SYC: {
    'code-source': 'iso',
    name: 'Seychelles',
    'alpha-2': 'SC',
    'alpha-3': 'SYC',
    'ioc-code': 'SEY',
    'country-code': '690'
  },
  SLE: {
    'code-source': 'iso',
    name: 'Sierra Leone',
    'alpha-2': 'SL',
    'alpha-3': 'SLE',
    'ioc-code': null,
    'country-code': '694'
  },
  SGP: {
    'code-source': 'iso',
    name: 'Singapore',
    'alpha-2': 'SG',
    'alpha-3': 'SGP',
    'ioc-code': null,
    'country-code': '702'
  },
  SXM: {
    'code-source': 'iso',
    name: 'Sint Maarten (Dutch part)',
    'alpha-2': 'SX',
    'alpha-3': 'SXM',
    'ioc-code': null,
    'country-code': '534'
  },
  SVK: {
    'code-source': 'iso',
    name: 'Slovakia',
    'alpha-2': 'SK',
    'alpha-3': 'SVK',
    'ioc-code': null,
    'country-code': '703'
  },
  SVN: {
    'code-source': 'iso',
    name: 'Slovenia',
    'alpha-2': 'SI',
    'alpha-3': 'SVN',
    'ioc-code': 'SLO',
    'country-code': '705'
  },
  SLB: {
    'code-source': 'iso',
    name: 'Solomon Islands',
    'alpha-2': 'SB',
    'alpha-3': 'SLB',
    'ioc-code': 'SOL',
    'country-code': '090'
  },
  SOM: {
    'code-source': 'iso',
    name: 'Somalia',
    'alpha-2': 'SO',
    'alpha-3': 'SOM',
    'ioc-code': null,
    'country-code': '706'
  },
  ZAF: {
    'code-source': 'iso',
    name: 'South Africa',
    'alpha-2': 'ZA',
    'alpha-3': 'ZAF',
    'ioc-code': 'RSA',
    'country-code': '710'
  },
  SGS: {
    'code-source': 'iso',
    name: 'South Georgia and the South Sandwich Islands',
    'alpha-2': 'GS',
    'alpha-3': 'SGS',
    'ioc-code': null,
    'country-code': '239'
  },
  SSD: {
    'code-source': 'iso',
    name: 'South Sudan',
    'alpha-2': 'SS',
    'alpha-3': 'SSD',
    'ioc-code': null,
    'country-code': '728'
  },
  ESP: {
    'code-source': 'iso',
    name: 'Spain',
    'alpha-2': 'ES',
    'alpha-3': 'ESP',
    'ioc-code': null,
    'country-code': '724'
  },
  LKA: {
    'code-source': 'iso',
    name: 'Sri Lanka',
    'alpha-2': 'LK',
    'alpha-3': 'LKA',
    'ioc-code': 'SRI',
    'country-code': '144'
  },
  SDN: {
    'code-source': 'iso',
    name: 'Sudan',
    'alpha-2': 'SD',
    'alpha-3': 'SDN',
    'ioc-code': 'SUD',
    'country-code': '729'
  },
  SUR: {
    'code-source': 'iso',
    name: 'Suriname',
    'alpha-2': 'SR',
    'alpha-3': 'SUR',
    'ioc-code': null,
    'country-code': '740'
  },
  SJM: {
    'code-source': 'iso',
    name: 'Svalbard and Jan Mayen',
    'alpha-2': 'SJ',
    'alpha-3': 'SJM',
    'ioc-code': null,
    'country-code': '744'
  },
  SWE: {
    'code-source': 'iso',
    name: 'Sweden',
    'alpha-2': 'SE',
    'alpha-3': 'SWE',
    'ioc-code': null,
    'country-code': '752'
  },
  CHE: {
    'code-source': 'iso',
    name: 'Switzerland',
    'alpha-2': 'CH',
    'alpha-3': 'CHE',
    'ioc-code': 'SUI',
    'country-code': '756'
  },
  SYR: {
    'code-source': 'iso',
    name: 'Syrian Arab Republic',
    'alpha-2': 'SY',
    'alpha-3': 'SYR',
    'ioc-code': null,
    'country-code': '760'
  },
  TWN: {
    'code-source': 'iso',
    name: 'Taiwan, Province of China',
    'alpha-2': 'TW',
    'alpha-3': 'TWN',
    'ioc-code': null,
    'country-code': '158'
  },
  TJK: {
    'code-source': 'iso',
    name: 'Tajikistan',
    'alpha-2': 'TJ',
    'alpha-3': 'TJK',
    'ioc-code': null,
    'country-code': '762'
  },
  TZA: {
    'code-source': 'iso',
    name: 'Tanzania, United Republic of',
    'alpha-2': 'TZ',
    'alpha-3': 'TZA',
    'ioc-code': 'TAN',
    'country-code': '834'
  },
  THA: {
    'code-source': 'iso',
    name: 'Thailand',
    'alpha-2': 'TH',
    'alpha-3': 'THA',
    'ioc-code': null,
    'country-code': '764'
  },
  TLS: {
    'code-source': 'iso',
    name: 'Timor-Leste',
    'alpha-2': 'TL',
    'alpha-3': 'TLS',
    'ioc-code': null,
    'country-code': '626'
  },
  TGO: {
    'code-source': 'iso',
    name: 'Togo',
    'alpha-2': 'TG',
    'alpha-3': 'TGO',
    'ioc-code': 'TOG',
    'country-code': '768'
  },
  TKL: {
    'code-source': 'iso',
    name: 'Tokelau',
    'alpha-2': 'TK',
    'alpha-3': 'TKL',
    'ioc-code': null,
    'country-code': '772'
  },
  TON: {
    'code-source': 'iso',
    name: 'Tonga',
    'alpha-2': 'TO',
    'alpha-3': 'TON',
    'ioc-code': 'TGA',
    'country-code': '776'
  },
  TTO: {
    'code-source': 'iso',
    name: 'Trinidad and Tobago',
    'alpha-2': 'TT',
    'alpha-3': 'TTO',
    'ioc-code': null,
    'country-code': '780'
  },
  TUN: {
    'code-source': 'iso',
    name: 'Tunisia',
    'alpha-2': 'TN',
    'alpha-3': 'TUN',
    'ioc-code': null,
    'country-code': '788'
  },
  TUR: {
    'code-source': 'iso',
    name: 'Turkey',
    'alpha-2': 'TR',
    'alpha-3': 'TUR',
    'ioc-code': null,
    'country-code': '792'
  },
  TKM: {
    'code-source': 'iso',
    name: 'Turkmenistan',
    'alpha-2': 'TM',
    'alpha-3': 'TKM',
    'ioc-code': null,
    'country-code': '795'
  },
  TCA: {
    'code-source': 'iso',
    name: 'Turks and Caicos Islands',
    'alpha-2': 'TC',
    'alpha-3': 'TCA',
    'ioc-code': null,
    'country-code': '796'
  },
  TUV: {
    'code-source': 'iso',
    name: 'Tuvalu',
    'alpha-2': 'TV',
    'alpha-3': 'TUV',
    'ioc-code': null,
    'country-code': '798'
  },
  UGA: {
    'code-source': 'iso',
    name: 'Uganda',
    'alpha-2': 'UG',
    'alpha-3': 'UGA',
    'ioc-code': null,
    'country-code': '800'
  },
  UKR: {
    'code-source': 'iso',
    name: 'Ukraine',
    'alpha-2': 'UA',
    'alpha-3': 'UKR',
    'ioc-code': null,
    'country-code': '804'
  },
  ARE: {
    'code-source': 'iso',
    name: 'United Arab Emirates',
    'alpha-2': 'AE',
    'alpha-3': 'ARE',
    'ioc-code': 'UAE',
    'country-code': '784'
  },
  GBR: {
    'code-source': 'iso',
    name: 'United Kingdom of Great Britain and Northern Ireland',
    'alpha-2': 'GB',
    'alpha-3': 'GBR',
    'ioc-code': null,
    'country-code': '826'
  },
  USA: {
    'code-source': 'iso',
    name: 'United States of America',
    'alpha-2': 'US',
    'alpha-3': 'USA',
    'ioc-code': null,
    'country-code': '840'
  },
  UMI: {
    'code-source': 'iso',
    name: 'United States Minor Outlying Islands',
    'alpha-2': 'UM',
    'alpha-3': 'UMI',
    'ioc-code': null,
    'country-code': '581'
  },
  URY: {
    'code-source': 'iso',
    name: 'Uruguay',
    'alpha-2': 'UY',
    'alpha-3': 'URY',
    'ioc-code': 'URU',
    'country-code': '858'
  },
  UZB: {
    'code-source': 'iso',
    name: 'Uzbekistan',
    'alpha-2': 'UZ',
    'alpha-3': 'UZB',
    'ioc-code': null,
    'country-code': '860'
  },
  VUT: {
    'code-source': 'iso',
    name: 'Vanuatu',
    'alpha-2': 'VU',
    'alpha-3': 'VUT',
    'ioc-code': 'VAN',
    'country-code': '548'
  },
  VEN: {
    'code-source': 'iso',
    name: 'Venezuela (Bolivarian Republic of)',
    'alpha-2': 'VE',
    'alpha-3': 'VEN',
    'ioc-code': null,
    'country-code': '862'
  },
  VNM: {
    'code-source': 'iso',
    name: 'Viet Nam',
    'alpha-2': 'VN',
    'alpha-3': 'VNM',
    'ioc-code': 'VIE',
    'country-code': '704'
  },
  VGB: {
    'code-source': 'iso',
    name: 'Virgin Islands (British)',
    'alpha-2': 'VG',
    'alpha-3': 'VGB',
    'ioc-code': 'IVB',
    'country-code': '092'
  },
  VIR: {
    'code-source': 'iso',
    name: 'Virgin Islands (U.S.)',
    'alpha-2': 'VI',
    'alpha-3': 'VIR',
    'ioc-code': 'ISV',
    'country-code': '850'
  },
  WLF: {
    'code-source': 'iso',
    name: 'Wallis and Futuna',
    'alpha-2': 'WF',
    'alpha-3': 'WLF',
    'ioc-code': null,
    'country-code': '876'
  },
  ESH: {
    'code-source': 'iso',
    name: 'Western Sahara',
    'alpha-2': 'EH',
    'alpha-3': 'ESH',
    'ioc-code': null,
    'country-code': '732'
  },
  YEM: {
    'code-source': 'iso',
    name: 'Yemen',
    'alpha-2': 'YE',
    'alpha-3': 'YEM',
    'ioc-code': null,
    'country-code': '887'
  },
  ZMB: {
    'code-source': 'iso',
    name: 'Zambia',
    'alpha-2': 'ZM',
    'alpha-3': 'ZMB',
    'ioc-code': 'ZAM',
    'country-code': '894'
  },
  ZWE: {
    'code-source': 'iso',
    name: 'Zimbabwe',
    'alpha-2': 'ZW',
    'alpha-3': 'ZWE',
    'ioc-code': 'ZIM',
    'country-code': '716'
  },
  ALG: {
    'code-source': 'ioc',
    name: 'Algeria',
    'alpha-2': 'DZ',
    'alpha-3': 'DZA',
    'country-code': '012',
    'ioc-code': 'ALG'
  },
  ANG: {
    'code-source': 'ioc',
    name: 'Angola',
    'alpha-2': 'AO',
    'alpha-3': 'AGO',
    'country-code': '024',
    'ioc-code': 'ANG'
  },
  ANT: {
    'code-source': 'ioc',
    name: 'Antigua and Barbuda',
    'alpha-2': 'AG',
    'alpha-3': 'ATG',
    'country-code': '028',
    'ioc-code': 'ANT'
  },
  ARU: {
    'code-source': 'ioc',
    name: 'Aruba',
    'alpha-2': 'AW',
    'alpha-3': 'ABW',
    'country-code': '533',
    'ioc-code': 'ARU'
  },
  ASA: {
    'code-source': 'ioc',
    name: 'American Samoa',
    'alpha-2': 'AS',
    'alpha-3': 'ASM',
    'country-code': '016',
    'ioc-code': 'ASA'
  },
  BAH: {
    'code-source': 'ioc',
    name: 'The Bahamas',
    'alpha-2': 'BS',
    'alpha-3': 'BHS',
    'country-code': '044',
    'ioc-code': 'BAH'
  },
  BAN: {
    'code-source': 'ioc',
    name: 'Bangladesh',
    'alpha-2': 'BD',
    'alpha-3': 'BGD',
    'country-code': '050',
    'ioc-code': 'BAN'
  },
  BAR: {
    'code-source': 'ioc',
    name: 'Barbados',
    'alpha-2': 'BB',
    'alpha-3': 'BRB',
    'country-code': '052',
    'ioc-code': 'BAR'
  },
  BER: {
    'code-source': 'ioc',
    name: 'Bermuda',
    'alpha-2': 'BM',
    'alpha-3': 'BMU',
    'country-code': '060',
    'ioc-code': 'BER'
  },
  BHU: {
    'code-source': 'ioc',
    name: 'Bhutan',
    'alpha-2': 'BT',
    'alpha-3': 'BTN',
    'country-code': '064',
    'ioc-code': 'BHU'
  },
  BIZ: {
    'code-source': 'ioc',
    name: 'Belize',
    'alpha-2': 'BZ',
    'alpha-3': 'BLZ',
    'country-code': '084',
    'ioc-code': 'BIZ'
  },
  BOT: {
    'code-source': 'ioc',
    name: 'Botswana',
    'alpha-2': 'BW',
    'alpha-3': 'BWA',
    'country-code': '072',
    'ioc-code': 'BOT'
  },
  BRU: {
    'code-source': 'ioc',
    name: 'Brunei',
    'alpha-2': 'BN',
    'alpha-3': 'BRN',
    'country-code': '096',
    'ioc-code': 'BRU'
  },
  BUL: {
    'code-source': 'ioc',
    name: 'Bulgaria',
    'alpha-2': 'BG',
    'alpha-3': 'BGR',
    'country-code': '100',
    'ioc-code': 'BUL'
  },
  BUR: {
    'code-source': 'ioc',
    name: 'Burkina Faso',
    'alpha-2': 'BF',
    'alpha-3': 'BFA',
    'country-code': '854',
    'ioc-code': 'BUR'
  },
  CAY: {
    'code-source': 'ioc',
    name: 'Cayman Islands',
    'alpha-2': 'KY',
    'alpha-3': 'CYM',
    'country-code': '136',
    'ioc-code': 'CAY'
  },
  CGO: {
    'code-source': 'ioc',
    name: 'Republic of the Congo',
    'alpha-2': 'CG',
    'alpha-3': 'COG',
    'country-code': '178',
    'ioc-code': 'CGO'
  },
  CHA: {
    'code-source': 'ioc',
    name: 'Chad',
    'alpha-2': 'TD',
    'alpha-3': 'TCD',
    'country-code': '148',
    'ioc-code': 'CHA'
  },
  CHI: {
    'code-source': 'ioc',
    name: 'Chile',
    'alpha-2': 'CL',
    'alpha-3': 'CHL',
    'country-code': '152',
    'ioc-code': 'CHI'
  },
  CRC: {
    'code-source': 'ioc',
    name: 'Costa Rica',
    'alpha-2': 'CR',
    'alpha-3': 'CRI',
    'country-code': '188',
    'ioc-code': 'CRC'
  },
  CRO: {
    'code-source': 'ioc',
    name: 'Croatia',
    'alpha-2': 'HR',
    'alpha-3': 'HRV',
    'country-code': '191',
    'ioc-code': 'CRO'
  },
  DEN: {
    'code-source': 'ioc',
    name: 'Denmark',
    'alpha-2': 'DK',
    'alpha-3': 'DNK',
    'country-code': '208',
    'ioc-code': 'DEN'
  },
  ESA: {
    'code-source': 'ioc',
    name: 'El Salvador',
    'alpha-2': 'SV',
    'alpha-3': 'SLV',
    'country-code': '222',
    'ioc-code': 'ESA'
  },
  FIJ: {
    'code-source': 'ioc',
    name: 'Fiji',
    'alpha-2': 'FJ',
    'alpha-3': 'FJI',
    'country-code': '242',
    'ioc-code': 'FIJ'
  },
  GBS: {
    'code-source': 'ioc',
    name: 'Guinea-Bissau',
    'alpha-2': 'GW',
    'alpha-3': 'GNB',
    'country-code': '624',
    'ioc-code': 'GBS'
  },
  GEQ: {
    'code-source': 'ioc',
    name: 'Equatorial Guinea',
    'alpha-2': 'GQ',
    'alpha-3': 'GNQ',
    'country-code': '226',
    'ioc-code': 'GEQ'
  },
  GER: {
    'code-source': 'ioc',
    name: 'Germany',
    'alpha-2': 'DE',
    'alpha-3': 'DEU',
    'country-code': '276',
    'ioc-code': 'GER'
  },
  GRE: {
    'code-source': 'ioc',
    name: 'Greece',
    'alpha-2': 'GR',
    'alpha-3': 'GRC',
    'country-code': '300',
    'ioc-code': 'GRE'
  },
  GRN: {
    'code-source': 'ioc',
    name: 'Grenada',
    'alpha-2': 'GD',
    'alpha-3': 'GRD',
    'country-code': '308',
    'ioc-code': 'GRN'
  },
  GUA: {
    'code-source': 'ioc',
    name: 'Guatemala',
    'alpha-2': 'GT',
    'alpha-3': 'GTM',
    'country-code': '320',
    'ioc-code': 'GUA'
  },
  GUI: {
    'code-source': 'ioc',
    name: 'Guinea',
    'alpha-2': 'GN',
    'alpha-3': 'GIN',
    'country-code': '324',
    'ioc-code': 'GUI'
  },
  HAI: {
    'code-source': 'ioc',
    name: 'Haiti',
    'alpha-2': 'HT',
    'alpha-3': 'HTI',
    'country-code': '332',
    'ioc-code': 'HAI'
  },
  HON: {
    'code-source': 'ioc',
    name: 'Honduras',
    'alpha-2': 'HN',
    'alpha-3': 'HND',
    'country-code': '340',
    'ioc-code': 'HON'
  },
  INA: {
    'code-source': 'ioc',
    name: 'Indonesia',
    'alpha-2': 'ID',
    'alpha-3': 'IDN',
    'country-code': '360',
    'ioc-code': 'INA'
  },
  IRI: {
    'code-source': 'ioc',
    name: 'Iran',
    'alpha-2': 'IR',
    'alpha-3': 'IRN',
    'country-code': '364',
    'ioc-code': 'IRI'
  },
  ISV: {
    'code-source': 'ioc',
    name: 'United States Virgin Islands',
    'alpha-2': 'VI',
    'alpha-3': 'VIR',
    'country-code': '850',
    'ioc-code': 'ISV'
  },
  IVB: {
    'code-source': 'ioc',
    name: 'British Virgin Islands',
    'alpha-2': 'VG',
    'alpha-3': 'VGB',
    'country-code': '092',
    'ioc-code': 'IVB'
  },
  KOS: {
    'code-source': 'ioc',
    name: 'Kosovo',
    'alpha-2': 'XK',
    'alpha-3': 'XKX',
    'country-code': null,
    'ioc-code': 'KOS'
  },
  KSA: {
    'code-source': 'ioc',
    name: 'Saudi Arabia',
    'alpha-2': 'SA',
    'alpha-3': 'SAU',
    'country-code': '682',
    'ioc-code': 'KSA'
  },
  KUW: {
    'code-source': 'ioc',
    name: 'Kuwait',
    'alpha-2': 'KW',
    'alpha-3': 'KWT',
    'country-code': '414',
    'ioc-code': 'KUW'
  },
  LAT: {
    'code-source': 'ioc',
    name: 'Latvia',
    'alpha-2': 'LV',
    'alpha-3': 'LVA',
    'country-code': '428',
    'ioc-code': 'LAT'
  },
  LBA: {
    'code-source': 'ioc',
    name: 'Libya',
    'alpha-2': 'LY',
    'alpha-3': 'LBY',
    'country-code': '434',
    'ioc-code': 'LBA'
  },
  LES: {
    'code-source': 'ioc',
    name: 'Lesotho',
    'alpha-2': 'LS',
    'alpha-3': 'LSO',
    'country-code': '426',
    'ioc-code': 'LES'
  },
  MAD: {
    'code-source': 'ioc',
    name: 'Madagascar',
    'alpha-2': 'MG',
    'alpha-3': 'MDG',
    'country-code': '450',
    'ioc-code': 'MAD'
  },
  MAS: {
    'code-source': 'ioc',
    name: 'Malaysia',
    'alpha-2': 'MY',
    'alpha-3': 'MYS',
    'country-code': '458',
    'ioc-code': 'MAS'
  },
  MAW: {
    'code-source': 'ioc',
    name: 'Malawi',
    'alpha-2': 'MW',
    'alpha-3': 'MWI',
    'country-code': '454',
    'ioc-code': 'MAW'
  },
  MGL: {
    'code-source': 'ioc',
    name: 'Mongolia',
    'alpha-2': 'MN',
    'alpha-3': 'MNG',
    'country-code': '496',
    'ioc-code': 'MGL'
  },
  MON: {
    'code-source': 'ioc',
    name: 'Monaco',
    'alpha-2': 'MC',
    'alpha-3': 'MCO',
    'country-code': '492',
    'ioc-code': 'MON'
  },
  MRI: {
    'code-source': 'ioc',
    name: 'Mauritius',
    'alpha-2': 'MU',
    'alpha-3': 'MUS',
    'country-code': '480',
    'ioc-code': 'MRI'
  },
  MTN: {
    'code-source': 'ioc',
    name: 'Mauritania',
    'alpha-2': 'MR',
    'alpha-3': 'MRT',
    'country-code': '478',
    'ioc-code': 'MTN'
  },
  MYA: {
    'code-source': 'ioc',
    name: 'Myanmar',
    'alpha-2': 'MM',
    'alpha-3': 'MMR',
    'country-code': '104',
    'ioc-code': 'MYA'
  },
  NCA: {
    'code-source': 'ioc',
    name: 'Nicaragua',
    'alpha-2': 'NI',
    'alpha-3': 'NIC',
    'country-code': '558',
    'ioc-code': 'NCA'
  },
  NED: {
    'code-source': 'ioc',
    name: 'Netherlands',
    'alpha-2': 'NL',
    'alpha-3': 'NLD',
    'country-code': '528',
    'ioc-code': 'NED'
  },
  NEP: {
    'code-source': 'ioc',
    name: 'Nepal',
    'alpha-2': 'NP',
    'alpha-3': 'NPL',
    'country-code': '524',
    'ioc-code': 'NEP'
  },
  NGR: {
    'code-source': 'ioc',
    name: 'Nigeria',
    'alpha-2': 'NG',
    'alpha-3': 'NGA',
    'country-code': '566',
    'ioc-code': 'NGR'
  },
  NIG: {
    'code-source': 'ioc',
    name: 'Niger',
    'alpha-2': 'NE',
    'alpha-3': 'NER',
    'country-code': '562',
    'ioc-code': 'NIG'
  },
  OMA: {
    'code-source': 'ioc',
    name: 'Oman',
    'alpha-2': 'OM',
    'alpha-3': 'OMN',
    'country-code': '512',
    'ioc-code': 'OMA'
  },
  PAR: {
    'code-source': 'ioc',
    name: 'Paraguay',
    'alpha-2': 'PY',
    'alpha-3': 'PRY',
    'country-code': '600',
    'ioc-code': 'PAR'
  },
  PHI: {
    'code-source': 'ioc',
    name: 'Philippines',
    'alpha-2': 'PH',
    'alpha-3': 'PHL',
    'country-code': '608',
    'ioc-code': 'PHI'
  },
  PLE: {
    'code-source': 'ioc',
    name: 'State of Palestine',
    'alpha-2': 'PS',
    'alpha-3': 'PSE',
    'country-code': '275',
    'ioc-code': 'PLE'
  },
  POR: {
    'code-source': 'ioc',
    name: 'Portugal',
    'alpha-2': 'PT',
    'alpha-3': 'PRT',
    'country-code': '620',
    'ioc-code': 'POR'
  },
  PUR: {
    'code-source': 'ioc',
    name: 'Puerto Rico',
    'alpha-2': 'PR',
    'alpha-3': 'PRI',
    'country-code': '630',
    'ioc-code': 'PUR'
  },
  RSA: {
    'code-source': 'ioc',
    name: 'South Africa',
    'alpha-2': 'ZA',
    'alpha-3': 'ZAF',
    'country-code': '710',
    'ioc-code': 'RSA'
  },
  SEY: {
    'code-source': 'ioc',
    name: 'Seychelles',
    'alpha-2': 'SC',
    'alpha-3': 'SYC',
    'country-code': '690',
    'ioc-code': 'SEY'
  },
  SKN: {
    'code-source': 'ioc',
    name: 'Saint Kitts and Nevis',
    'alpha-2': 'KN',
    'alpha-3': 'KNA',
    'country-code': '659',
    'ioc-code': 'SKN'
  },
  SLO: {
    'code-source': 'ioc',
    name: 'Slovenia',
    'alpha-2': 'SI',
    'alpha-3': 'SVN',
    'country-code': '705',
    'ioc-code': 'SLO'
  },
  SOL: {
    'code-source': 'ioc',
    name: 'Solomon Islands',
    'alpha-2': 'SB',
    'alpha-3': 'SLB',
    'country-code': '090',
    'ioc-code': 'SOL'
  },
  SRI: {
    'code-source': 'ioc',
    name: 'Sri Lanka',
    'alpha-2': 'LK',
    'alpha-3': 'LKA',
    'country-code': '144',
    'ioc-code': 'SRI'
  },
  SUD: {
    'code-source': 'ioc',
    name: 'Sudan',
    'alpha-2': 'SD',
    'alpha-3': 'SDN',
    'country-code': '729',
    'ioc-code': 'SUD'
  },
  SUI: {
    'code-source': 'ioc',
    name: 'Switzerland',
    'alpha-2': 'CH',
    'alpha-3': 'CHE',
    'country-code': '756',
    'ioc-code': 'SUI'
  },
  TAN: {
    'code-source': 'ioc',
    name: 'Tanzania',
    'alpha-2': 'TZ',
    'alpha-3': 'TZA',
    'country-code': '834',
    'ioc-code': 'TAN'
  },
  TGA: {
    'code-source': 'ioc',
    name: 'Tonga',
    'alpha-2': 'TO',
    'alpha-3': 'TON',
    'country-code': '776',
    'ioc-code': 'TGA'
  },
  TOG: {
    'code-source': 'ioc',
    name: 'Togo',
    'alpha-2': 'TG',
    'alpha-3': 'TGO',
    'country-code': '768',
    'ioc-code': 'TOG'
  },
  UAE: {
    'code-source': 'ioc',
    name: 'United Arab Emirates',
    'alpha-2': 'AE',
    'alpha-3': 'ARE',
    'country-code': '784',
    'ioc-code': 'UAE'
  },
  URU: {
    'code-source': 'ioc',
    name: 'Uruguay',
    'alpha-2': 'UY',
    'alpha-3': 'URY',
    'country-code': '858',
    'ioc-code': 'URU'
  },
  VAN: {
    'code-source': 'ioc',
    name: 'Vanuatu',
    'alpha-2': 'VU',
    'alpha-3': 'VUT',
    'country-code': '548',
    'ioc-code': 'VAN'
  },
  VIE: {
    'code-source': 'ioc',
    name: 'Vietnam',
    'alpha-2': 'VN',
    'alpha-3': 'VNM',
    'country-code': '704',
    'ioc-code': 'VIE'
  },
  VIN: {
    'code-source': 'ioc',
    name: 'Saint Vincent and the Grenadines',
    'alpha-2': 'VC',
    'alpha-3': 'VCT',
    'country-code': '670',
    'ioc-code': 'VIN'
  },
  ZAM: {
    'code-source': 'ioc',
    name: 'Zambia',
    'alpha-2': 'ZM',
    'alpha-3': 'ZMB',
    'country-code': '894',
    'ioc-code': 'ZAM'
  },
  ZIM: {
    'code-source': 'ioc',
    name: 'Zimbabwe',
    'alpha-2': 'ZW',
    'alpha-3': 'ZWE',
    'country-code': '716',
    'ioc-code': 'ZIM'
  }
};
